import React from 'react';
import { string, func, bool, object, oneOfType } from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames/bind';

import { Button, Modal, XMarkIcon } from '@snapask/common-components';

import styles from './ChangeSubscriptionModal.scss';
const cx = classnames.bind(styles);

function ChangeSubscriptionModal({
  title,
  description,
  figure,
  dismissButtonText,
  confirmButtonText,
  disabledConfirm,
  onDismiss,
  onConfirm,
  onClose,
  centered,
}) {
  return (
    <Modal>
      <div className={cx(styles.root, { centered })}>
        <div className={styles.inner}>
          <div className={styles.header}>
            <h5 className={styles.title}>
              {centered && (
                <XMarkIcon
                  onClick={onClose}
                  className={styles.closeButton}
                  width={14}
                  height={14}
                />
              )}
              {title}
            </h5>
          </div>
          <div className={styles.body}>{description}</div>
          {figure && <img className={styles.figure} src={figure} alt={title} />}
        </div>

        <div className={styles.footer}>
          <Button
            text={dismissButtonText}
            onClick={onDismiss}
            theme={styles}
            ghost
          />
          <Button
            disabled={disabledConfirm}
            text={confirmButtonText}
            onClick={onConfirm}
            primary
          />
        </div>
      </div>
    </Modal>
  );
}

ChangeSubscriptionModal.propTypes = {
  confirmButtonText: string.isRequired,
  description: oneOfType([string, object]).isRequired,
  dismissButtonText: string.isRequired,
  t: func.isRequired,
  title: string.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  centered: bool,
  disabledConfirm: bool,
  figure: string,
  onClose: func,
};

ChangeSubscriptionModal.defaultProps = {
  centered: false,
  disabledConfirm: false,
  figure: '',
  onClose: () => {},
};

export default translate(['account'])(ChangeSubscriptionModal);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountSubscriptions/components/ChangeSubscriptionModal/ChangeSubscriptionModal.jsx